module.exports = __webpack_public_path__ + "img/logo-date.205157b0.svg";